<div class="mb-6">
    <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-4 text-left flex items-center gap-3">
        <mat-icon class="text-4xl w-10 h-10 text-gray-700">tune</mat-icon>
        <span translate>ai-exam-onboarding.personalization.title</span>
    </h1>
    <p class="text-lg text-gray-700 text-left" translate>
        ai-exam-onboarding.personalization.description
    </p>
</div>

<!-- Langue maternelle (préremplie depuis le profil / la langue d'interface, à confirmer) -->
@if (!hideNativeLanguage) {
<div class="mb-8">
    <h2 class="text-lg font-semibold text-gray-900 mb-1">
        <span translate>ai-exam-onboarding.personalization.native-language.question</span>
    </h2>
    <p class="text-sm text-gray-500 mb-3" translate>ai-exam-onboarding.personalization.native-language.hint</p>
    <select
        class="px-5 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-900 cursor-pointer
               hover:border-primary focus:border-primary focus:outline-none transition-all duration-200"
        [value]="answers.native_language || ''"
        (change)="selectNativeLanguage($any($event.target).value)">
        <option value="" disabled translate>ai-exam-onboarding.personalization.native-language.placeholder</option>
        <option *ngFor="let option of nativeLanguageOptions" [value]="option.value">
            {{ option.label }}
        </option>
    </select>
</div>
}

<!-- Taille d'entreprise (obligatoire) -->
<div class="mb-8">
    <h2 class="text-lg font-semibold text-gray-900 mb-3">
        <span translate>ai-exam-onboarding.personalization.company-size.question</span>
        <span class="text-red-500">*</span>
    </h2>
    <div class="flex flex-wrap gap-3">
        <button *ngFor="let option of companySizeOptions" type="button"
            (click)="selectCompanySize(option.value)"
            [class.border-primary]="answers.company_size === option.value"
            [class.bg-primary-100]="answers.company_size === option.value"
            class="px-5 py-3 rounded-xl border-2 border-gray-200 hover:border-primary hover:bg-primary-50 cursor-pointer transition-all duration-200">
            <span translate>{{ option.labelKey }}</span>
        </button>
    </div>
</div>

<!-- Interlocuteurs habituels (multi-choix, skippable) -->
<div class="mb-8">
    <h2 class="text-lg font-semibold text-gray-900 mb-1">
        <span translate>ai-exam-onboarding.personalization.interlocutors.question</span>
    </h2>
    <p class="text-sm text-gray-500 mb-3" translate>ai-exam-onboarding.personalization.optional-hint</p>
    <div class="flex flex-wrap gap-3">
        <button *ngFor="let option of interlocutorOptions" type="button"
            (click)="toggleInterlocutor(option.value)"
            [class.border-primary]="isInterlocutorSelected(option.value)"
            [class.bg-primary-100]="isInterlocutorSelected(option.value)"
            class="px-5 py-3 rounded-xl border-2 border-gray-200 hover:border-primary hover:bg-primary-50 cursor-pointer transition-all duration-200">
            <span translate>{{ option.labelKey }}</span>
        </button>
    </div>
</div>

<!-- Position de management (oui/non, skippable) -->
<div class="mb-8">
    <h2 class="text-lg font-semibold text-gray-900 mb-1">
        <span translate>ai-exam-onboarding.personalization.is-manager.question</span>
    </h2>
    <p class="text-sm text-gray-500 mb-3" translate>ai-exam-onboarding.personalization.optional-hint</p>
    <div class="flex flex-wrap gap-3">
        <button type="button" (click)="selectIsManager(true)"
            [class.border-primary]="answers.is_manager === true"
            [class.bg-primary-100]="answers.is_manager === true"
            class="px-5 py-3 rounded-xl border-2 border-gray-200 hover:border-primary hover:bg-primary-50 cursor-pointer transition-all duration-200">
            <span translate>ai-exam-onboarding.personalization.yes</span>
        </button>
        <button type="button" (click)="selectIsManager(false)"
            [class.border-primary]="answers.is_manager === false"
            [class.bg-primary-100]="answers.is_manager === false"
            class="px-5 py-3 rounded-xl border-2 border-gray-200 hover:border-primary hover:bg-primary-50 cursor-pointer transition-all duration-200">
            <span translate>ai-exam-onboarding.personalization.no</span>
        </button>
    </div>
</div>

<!-- Taille d'équipe (si manager) -->
<div class="mb-8" *ngIf="answers.is_manager === true">
    <h2 class="text-lg font-semibold text-gray-900 mb-1">
        <span translate>ai-exam-onboarding.personalization.team-size.question</span>
    </h2>
    <p class="text-sm text-gray-500 mb-3" translate>ai-exam-onboarding.personalization.optional-hint</p>
    <div class="flex flex-wrap gap-3">
        <button *ngFor="let option of teamSizeOptions" type="button"
            (click)="selectTeamSize(option.value)"
            [class.border-primary]="answers.team_size === option.value"
            [class.bg-primary-100]="answers.team_size === option.value"
            class="px-5 py-3 rounded-xl border-2 border-gray-200 hover:border-primary hover:bg-primary-50 cursor-pointer transition-all duration-200">
            <span translate>{{ option.labelKey }}</span>
        </button>
    </div>
</div>
